import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, AlertTriangle } from 'lucide-react';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <AlertTriangle className="mx-auto text-amber-400 mb-4" size={64} />
        <h1 className="text-6xl font-bold text-content-primary mb-2">404</h1>
        <h2 className="text-xl font-semibold text-content-secondary mb-4">Page Not Found</h2>
        <p className="text-content-tertiary mb-8 max-w-md mx-auto">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button
          onClick={() => navigate('/')}
          className="inline-flex items-center gap-2 bg-primary text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors font-medium"
        >
          <Home size={20} />
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
